import { Division, Offer } from "../../services/consultation.service";
import { DefinitionIdentifier } from "../../data/product";

export class MainSectionInfo {
    constructor(
        public key: string,
        public label: string,
    ) {}
}

export class ViewState {
    constructor(
        public protocolLoadFailed = false,
        public selectedMainSection: MainSectionInfo = null,
    ) {}
}
